import React from 'react';
import { normalizeStatus, getStatusLabelValue } from '../../utils/statusUtils';

const STATUS_VARIANT = {
  completed: 'success',
  terminé: 'success',
  'مكتمل': 'success',
  true: 'success',
  '1': 'success',
  active: 'success',
  pending: 'warning',
  'en attente': 'warning',
  'في الانتظار': 'warning',
  processing: 'warning',
  'en cours': 'warning',
  cancelled: 'danger',
  annulé: 'danger',
  'ملغي': 'danger',
  false: 'danger',
  '0': 'danger',
  inactive: 'neutral',
};

function resolveBadgeVariant(status) {
  const key = normalizeStatus(status);
  return STATUS_VARIANT[key] || 'neutral';
}

/**
 * ADS status badge (Phase 1).
 */
const AdsBadge = ({ status, variant, children, className = '' }) => {
  const resolvedVariant = variant || resolveBadgeVariant(status);
  const classes = ['ads-badge', `ads-badge--${resolvedVariant}`, className].filter(Boolean).join(' ');

  return (
    <span className={classes}>
      {children ?? getStatusLabelValue(status)}
    </span>
  );
};

export default AdsBadge;
